import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

function BaseButton(props) {
  // ✅ 1. เพิ่ม `disabled` เข้ามารับค่าจาก props
  const { text, tooltip, variant, color, icon, onClick, sorgcode, codition, disabled } =
    props;

  return (
    <Tooltip title={tooltip} arrow>
      {/* ✅ 2. ห่อด้วย span เพื่อให้ Tooltip ทำงานได้แม้ปุ่มจะโดน disabled (พฤติกรรมปกติของ MUI) */}
      <span style={{ display: 'inline-block' }}>
        <Button
          // ✅ 3. เอาเงื่อนไข disabled ที่รับมาจาก InvoiceMain (SALE_ROLE) มาเชื่อมกับเงื่อนไขเดิมของคุณ
          disabled={disabled || (sorgcode !== 'INET' && codition === 'JV')}
          size="small"
          variant={variant}
          color={color}
          sx={{
            borderRadius: 6,
            fontSize: 12,
            height: '35px',
            color: variant === 'contained' && 'white',
            width: {
              xs: '200px',
              lg:'200px'
            },
          }}
          startIcon={icon}
          onClick={onClick}
        >
          {text}
        </Button>
      </span>
    </Tooltip>
  );
}

BaseButton.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.string,
  disabled: PropTypes.bool, // ✅ เพิ่มการตรวจสอบ Type ของ disabled
};

BaseButton.defaultProps = {
  variant: 'outlined',
  disabled: false, // ✅ ตั้งค่าเริ่มต้นให้ไม่โดน disable
};

export default BaseButton;